var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeletePopup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3644_40198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.203 38.6107L30.0917 5.50898C29.029 3.66836 27.1256 2.56934 25 2.56934C22.8745 2.56934 20.971 3.66836 19.9083 5.50898L0.797093 38.6106C-0.265698 40.4514 -0.265698 42.6492 0.797093 44.49C1.85988 46.3307 3.7632 47.4296 5.88878 47.4296H44.1112C46.2367 47.4296 48.1401 46.3306 49.203 44.4901C50.2658 42.6492 50.2658 40.4514 49.203 38.6107ZM46.666 43.0254C46.1328 43.949 45.1777 44.5004 44.1112 44.5004H5.88878C4.82218 44.5004 3.86711 43.949 3.33391 43.0254C2.8007 42.1018 2.8007 40.999 3.33391 40.0754L22.4453 6.97372C22.9785 6.05009 23.9336 5.49872 25.0001 5.49872C26.0665 5.49872 27.0217 6.05009 27.5549 6.97372L46.6661 40.0754C47.1993 40.999 47.1993 42.1018 46.666 43.0254Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4644 17.1885H23.5352V31.8351H26.4644V17.1885Z",
    fill: "#FF3B30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 34.7646C23.9229 34.7646 23.0469 35.6407 23.0469 36.7176C23.0469 37.7944 23.9229 38.6705 24.9998 38.6705C26.0766 38.6705 26.9527 37.7944 26.9527 36.7176C26.9527 35.6407 26.0767 34.7646 24.9998 34.7646Z",
    fill: "#FF3B30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3644_40198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePopup);
export default __webpack_public_path__ + "static/media/deletePopup.6205e64de16b4126df9ade852923e32f.svg";
export { ForwardRef as ReactComponent };